import clsx from 'clsx';

import type { IconProps } from '.';

/**
 * Menu Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const MenuIcon = ({ className, fill = 'white' }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={fill}
    className={clsx('nav_ham_icon', className)}
  >
    <rect x="4" y="8" width="16" height="1" />
    <rect x="4" y="15" width="16" height="1" />
  </svg>
);

export default MenuIcon;
